import { Component, OnInit } from '@angular/core';
import {CommonService} from "../common.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-benchmark',
  templateUrl: './benchmark.component.html',
  styleUrls: ['./benchmark.component.css']
})
export class BenchmarkComponent implements OnInit {
  masterApi: any;
  totalCampus: number = 0;
  campusInfo: any;
  finalCampusArr : any;
  AllCampusArr = {'name':[], 'count':0, 'countBelow':0};
  // campusArr:any[];
  constructor(public commonService: CommonService,private router: Router) {

    this.campusInfo = this.commonService.getAuditInfo();
    this.campusInfo.forEach((value: any) => {
      this.totalCampus = this.totalCampus + value['facilitators'].length;
    });
    this.masterApi = this.commonService.getMasterApi();
    console.log(this.commonService.getMasterApi())

let campusArr = [];

    this.campusInfo.forEach(function (result: any) {
      let countBelow : any = 0;
      let subCampArr =  [];
        subCampArr['count'] = result.facilitators.length;
        let name :any = [];
      result.facilitators.forEach(function (facilitators: any) {
        if(facilitators.audits){
          //noinspection TypeScriptUnresolvedFunction
            if(Object.values(facilitators.audits[facilitators.audits.length - 1].auditData).indexOf(1) != -1){
              countBelow = countBelow + 1;
              name.push(facilitators.name);
          }
        }
      });
        subCampArr['countBelow'] = countBelow;
        subCampArr['name'] = name;
        campusArr.push(subCampArr);
    });
    this.finalCampusArr = campusArr; //dynamic array
     console.log(this.finalCampusArr);
      let finalcountBelow : number = 0;
      let finalcount : number = 0;
      let finalname = [];
      this.finalCampusArr.forEach(function (result: any) {
          finalcountBelow = finalcountBelow + result.countBelow;
          finalcount = finalcount + result.count;
          finalname = finalname.concat(result.name);
      });
      this.AllCampusArr['name'] = finalname ;
      this.AllCampusArr['count'] = finalcount ;
      this.AllCampusArr['countBelow'] = finalcountBelow;
      console.log(this.AllCampusArr); // first array
  }

  calculateData(campusInfo){

}

  ngOnInit() {
    console.log("hii");
  }

}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/benchmark/benchmark.component.ts